import React, { useEffect, useState } from 'react';
import Debug from '../../Components/Debug/Debug';
import { Link, useNavigate } from 'react-router-dom';
import { urlManager } from '../../Utils/URL/URLManager';
import { Button, Container, Grid, Paper } from '@mui/material';
import BaseLayout from '../../Components/PageLayouts/BaseLayout/BaseLayout';
import { getAuthTokenStorage } from '../../Utils/Auth';

interface Props {}

const MainPage: React.FC<Props> = () => {
  const [cats, setCats] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const token = getAuthTokenStorage();

    if (!token || token === '') {
      navigate(urlManager.signIn());
      return;
    }

    fetch('http://localhost:3333/api/cats', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: getAuthTokenStorage(),
      },
    })
      .then(res => {
        if (res.status === 401) {
          throw res;
        }

        return res.json();
      })
      .then(res => {
        setCats(res.items);
      })
      .catch(e => {
        console.log('error', e);
        navigate(urlManager.signIn());
      });
  }, [navigate]);

  return (
    <BaseLayout>
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={8} lg={9}>
            <Paper
              sx={{
                p: 2,
                display: 'flex',
                flexDirection: 'column',
                height: 240,
              }}
            >
              <h1>MainPage</h1>
              <Link to={urlManager.admin().root()}>Admin Panel</Link>
            </Paper>
          </Grid>
          {/* Recent Deposits */}
          <Grid item xs={12} md={4} lg={3}>
            <Paper
              sx={{
                p: 2,
                display: 'flex',
                flexDirection: 'column',
                height: 240,
              }}
            >
              <Button>Hello</Button>
            </Paper>
          </Grid>
          {/* Recent Orders */}
          <Grid item xs={12}>
            <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
              <Debug data={cats} />
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </BaseLayout>
  );
};

export default MainPage;
